import { render, staticRenderFns } from "./postDetails.vue?vue&type=template&id=e20e88b0&"
import script from "./postDetails.vue?vue&type=script&lang=js&"
export * from "./postDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports